import { DocumentTemplateApi, documentTemplatesApi } from "api/documentTemplatesApi";
import { IDropdownOption } from "components/atoms";
import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";

export const useDocumentTemplates = (
  skip: number,
  limit: number,
  searchPhrase: string = "",
  filter: string = "",
  orderBy: string = "",
) => {
  const queryClient = useQueryClient();
  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.DOCUMENT_TEMPLATES(skip, limit, searchPhrase, filter, orderBy),
    queryFn: () => documentTemplatesApi.fetch(skip, limit, searchPhrase, filter, orderBy),
    placeholderData: keepPreviousData,
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.DOCUMENT_TEMPLATES(skip, limit, searchPhrase, filter, orderBy),
    });
  };

  return { invalidate, isLoading, isFetching, documentTemplates: data?.data.data ?? [], total: data?.data.total ?? 0 };
};

export interface DocumentTemplateOption extends IDropdownOption {
  template: DocumentTemplateApi | null;
}
export const useDocumentTemplatesOptions = () => {
  const { isLoading, documentTemplates } = useDocumentTemplates(0, 1_000_000);

  const options: DocumentTemplateOption[] = documentTemplates.map((x) => ({
    value: x.id.toString(),
    label: x.name,
    template: x,
  }));

  return { isLoading, options };
};
